import React, { Component } from 'react';
import { Col, FormGroup, Row } from 'reactstrap';
import HtmlHelpers from '../../HtmlHelpers';
import WmLabel from '../WmLabel';
export default class WmToggleRadioField extends Component {
  constructor() {
    super(...arguments);
    this.getCurrentValue = () => {
      let value = this.props.value;
      if (value === false) {
        value = 'false';
      }
      return (value || '').toString();
    };
    this.getYesNoField = () => {
      const val1 = (this.props.field1.value || '').toString();
      const val2 = (this.props.field2.value || '').toString();
      return /*#__PURE__*/React.createElement(Col, {
        md: this.props.fieldColumns
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: this.props.name,
        id: "".concat(this.props.name, "_").concat(val1),
        checked: this.getCurrentValue() === val1,
        value: val1,
        onChange: this.props.onChange,
        disabled: this.props.readOnly,
        required: this.props.isRequired
      }), "\xA0\xA0", /*#__PURE__*/React.createElement(WmLabel, {
        htmlFor: "".concat(this.props.name, "_").concat(val1),
        text: this.props.field1.label
      })), /*#__PURE__*/React.createElement(Col, {
        md: "6"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: this.props.name,
        id: "".concat(this.props.name, "_").concat(val2),
        checked: this.getCurrentValue() === val2,
        value: val2,
        onChange: this.props.onChange,
        disabled: this.props.readOnly
      }), "\xA0\xA0", /*#__PURE__*/React.createElement(WmLabel, {
        htmlFor: "".concat(this.props.name, "_").concat(val2),
        text: this.props.field2.label
      })), /*#__PURE__*/React.createElement("div", {
        className: "invalid-feedback"
      })));
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center"
    }, HtmlHelpers.getWmLabel(this.props), this.getYesNoField()));
  }
}